document.addEventListener("DOMContentLoaded", function () {
    // Swatch switching logic for all kv-product-cards globally
    document.body.addEventListener("click", function(e) {
        if (e.target.classList.contains("kv-kleur-swatch")) {
            e.preventDefault();
            const swatch = e.target;
            const card = swatch.closest(".kv-product-card");
            if (!card) return;
            
            const variantId = swatch.getAttribute("data-variant-id");
            
            card.querySelectorAll(".kv-kleur-swatch").forEach(s => s.classList.remove("kv-is-active"));
            swatch.classList.add("kv-is-active");

            card.querySelectorAll(".kv-product-card__image--variant").forEach(img => {
                if(img.getAttribute("data-variant-id") === variantId) {
                    img.classList.add("kv-is-active");
                } else {
                    img.classList.remove("kv-is-active");
                }
            });
        }
    });
});
